import type { ErrorEvent, StackFrame } from '@sentry/astro';

const ANONYMOUS_FILENAME = '<anonymous>';

const isAnonymousFrame = (frame: StackFrame) => frame.filename === ANONYMOUS_FILENAME;

export function isAnonymousStackEvent(event: ErrorEvent): boolean {
  const frames = (event.exception?.values ?? []).flatMap(entry => entry.stacktrace?.frames ?? []);
  return frames.length > 0 && frames.every(isAnonymousFrame);
}
